<section class="parametro-shell">
  <header class="parametro-hero">
    <div>
      <h2 class="parametro-title">{{ isEditMode ? 'Editar Parâmetro' : 'Novo Parâmetro' }}</h2>
      <p class="parametro-subtitle">Configure os parâmetros do sistema.</p>
    </div>
    <span class="parametro-chip">{{ isEditMode ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form (ngSubmit)="save()" id="parametroForm" class="parametro-card">
    <div class="form-section">
      <h3>Dados do Parâmetro</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="descricao" class="form-label">Descrição</label>
          <input type="text" class="form-control" id="descricao" [(ngModel)]="parametro.descricao" name="descricao" required>
        </div>
        <div class="col-md-6">
          <label for="categoria" class="form-label">Categoria</label>
          <input type="text" class="form-control" id="categoria" [(ngModel)]="parametro.categoria" name="categoria" required>
        </div>
        <div class="col-md-4">
          <label for="valorNumerico" class="form-label">Valor Numérico</label>
          <input type="text" class="form-control" id="valorNumerico" [(ngModel)]="parametro.valorNumerico" name="valorNumerico">
        </div>
        <div class="col-md-4">
          <label for="valorMinimo" class="form-label">Valor Mínimo</label>
          <input type="text" class="form-control" id="valorMinimo" [(ngModel)]="parametro.valorMinimo" name="valorMinimo">
        </div>
        <div class="col-md-4">
          <label for="valorMaximo" class="form-label">Valor Máximo</label>
          <input type="text" class="form-control" id="valorMaximo" [(ngModel)]="parametro.valorMaximo" name="valorMaximo">
        </div>
      </div>
    </div>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
    <button type="submit" form="parametroForm" class="btn btn-primary">Salvar</button>
  </footer>
</section>
